import { TranscoderProfile } from '@vxui/common';
import { TableSubHeader } from '@vxui/components';
import { Dispatch, FC, SetStateAction } from 'react';
import { SimplifiedTemplate } from '../profilesTable.types';
import { TableTemplateFilter } from './TableTemplateFilter';

type SubheaderContainerProps = {
  filterText: string;
  setFilterText: Dispatch<SetStateAction<string>>;
  selectedProfiles: TranscoderProfile[];
  subHeaderActions: JSX.Element | JSX.Element[];
  templateFilterState: [string, Dispatch<SetStateAction<string>>];
  templates: SimplifiedTemplate[];
};

export const SubheaderContainer: FC<SubheaderContainerProps> = ({
  filterText,
  setFilterText,
  selectedProfiles,
  subHeaderActions,
  templateFilterState,
  templates,
}) => {
  return (
    <TableSubHeader
      filter={{ filterText, setFilterText }}
      selectedCount={selectedProfiles.length}
      additionalFilters={<TableTemplateFilter state={templateFilterState} templates={templates} />}
    >
      {subHeaderActions}
    </TableSubHeader>
  );
};
